// A searchable tick-list for choosing several records (garments, fabrics, suppliers, standards) in a form.
// The ticked values are ordinary checkboxes named `name`, so forms read them with pickValues().
import { esc } from "./lib.js";

export function pickList(name: string, options: Array<{ id: string; label: string }>, selected: string[], o: { placeholder?: string; disabled?: boolean; empty?: string } = {}): string {
  const chosen = new Set(selected);
  // Ticked ones first, so what is linked is visible without scrolling.
  const sorted = [...options].sort((a, b) => Number(chosen.has(b.id)) - Number(chosen.has(a.id)));
  return `<div class="pick" data-pick="${esc(name)}">
${options.length > 6 ? `<input type="search" class="pick-filter" data-pick-filter placeholder="${esc(o.placeholder || "Search…")}" aria-label="${esc(o.placeholder || "Search")}">` : ""}
<div class="pick-list">${sorted.map((x) => `<label class="pick-row"><input type="checkbox" name="${esc(name)}" value="${esc(x.id)}" ${chosen.has(x.id) ? "checked" : ""} ${o.disabled ? "disabled" : ""}><span>${esc(x.label)}</span></label>`).join("") || `<div class="muted pick-empty">${esc(o.empty || "Nothing to choose from yet.")}</div>`}</div>
<small class="muted pick-count">${chosen.size} selected</small></div>`;
}
export const pickValues = (form: HTMLElement, name: string) => [...form.querySelectorAll<HTMLInputElement>(`input[type=checkbox][name="${name}"]:checked`)].map((x) => x.value);

document.addEventListener("input", (e) => {
  const f = (e.target as HTMLElement).closest<HTMLInputElement>("[data-pick-filter]");
  if (!f) return;
  const q = f.value.trim().toLowerCase();
  f.closest(".pick")?.querySelectorAll<HTMLElement>(".pick-row").forEach((r) => { r.hidden = !!q && !r.textContent!.toLowerCase().includes(q); });
});
document.addEventListener("change", (e) => {
  const box = (e.target as HTMLElement).closest<HTMLElement>(".pick");
  if (!box) return;
  const n = box.querySelectorAll("input[type=checkbox]:checked").length;
  const c = box.querySelector(".pick-count");
  if (c) c.textContent = `${n} selected`;
});
